import { Box } from "@mui/material";
import type { FC } from "react";
import { DashboardGradientLayer } from "web_myplann/Dashboard/Components/DashboardGradientLayer";
import { useGradientCrossFade } from "web_myplann/Dashboard/Hooks/useGradientCrossFade";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";
import { DASHBOARD_TRANSITION_DURATION_MS } from "web_myplann/Dashboard/Utils/dashboardLayout";
import {
	getDashboardGradient,
	getDashboardLinearGradient,
} from "web_myplann/Dashboard/Utils/getDashboardGradient";

type Props = {
	gradientFrom: string;
	gradientTo: string;
	height: number;
	animateHeight: boolean;
};

export const DashboardHeroGradient: FC<Props> = ({
	gradientFrom,
	gradientTo,
	height,
	animateHeight,
}) => {
	const isDashboardV2 = useIsDashboardV2();

	const gradient = isDashboardV2
		? getDashboardLinearGradient(gradientFrom, gradientTo)
		: getDashboardGradient(gradientFrom, gradientTo);
	const { slots, frontSlot } = useGradientCrossFade(gradient);

	return (
		<Box
			position="absolute"
			top={0}
			left={0}
			right={0}
			height={height}
			zIndex={0}
			sx={{
				background: isDashboardV2 ? slots[0] : gradient,
				pointerEvents: "none",
				transition: animateHeight
					? `height ${DASHBOARD_TRANSITION_DURATION_MS}ms ease-out`
					: "none",
			}}
		>
			{isDashboardV2 && (
				<DashboardGradientLayer
					gradient={slots[1]}
					isVisible={frontSlot === 1}
				/>
			)}
		</Box>
	);
};
